import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const Notification = forwardRef<Ref, Props>((props, ref) => (
    <svg
        width='18'
        height='17'
        viewBox='0 0 18 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <mask id='path-1-inside-1' fill='white'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.58367 0C5.67195 0 3.21476 2.16577 2.84912 5.05444L2.40458 8.56641C2.28108 9.5421 1.87258 10.4597 1.2302 11.2044L0.244728 12.3468C-0.314278 12.9949 0.146105 14 1.00194 14H8.58361H8.58367H16.1653C17.0212 14 17.4816 12.9949 16.9226 12.3468L15.9371 11.2044C15.2947 10.4597 14.8862 9.5421 14.7627 8.56641L14.3182 5.05444C13.9525 2.16577 11.4953 0 8.58367 0Z'
            />
        </mask>
        <path
            d='M2.84912 5.05444L3.8412 5.18002L2.84912 5.05444ZM2.40458 8.56641L1.41249 8.44083L2.40458 8.56641ZM1.2302 11.2044L1.98741 11.8576H1.98741L1.2302 11.2044ZM0.244728 12.3468L-0.51248 11.6937H-0.512481L0.244728 12.3468ZM16.9226 12.3468L17.6798 11.6937L16.9226 12.3468ZM15.9371 11.2044L15.1799 11.8576H15.1799L15.9371 11.2044ZM14.7627 8.56641L15.7548 8.44083L14.7627 8.56641ZM14.3182 5.05444L13.3261 5.18002V5.18002L14.3182 5.05444ZM3.8412 5.18002C4.14359 2.79109 6.17568 1 8.58367 1V-1C5.16821 -1 2.28593 1.54045 1.85703 4.92887L3.8412 5.18002ZM3.39666 8.69198L3.8412 5.18002L1.85703 4.92887L1.41249 8.44083L3.39666 8.69198ZM1.98741 11.8576C2.75826 10.9639 3.24846 9.86281 3.39666 8.69198L1.41249 8.44083C1.31369 9.22138 0.986895 9.95546 0.472991 10.5512L1.98741 11.8576ZM1.00194 13L1.98741 11.8576L0.472992 10.5512L-0.51248 11.6937L1.00194 13ZM1.00194 13L-0.512481 11.6937C-1.63049 12.9897 -0.709726 15 1.00194 15V13ZM8.58361 13H1.00194V15H8.58361V13ZM8.58361 15H8.58367V13H8.58361V15ZM8.58367 15H16.1653V13H8.58367V15ZM16.1653 15C17.877 15 18.7978 12.9897 17.6798 11.6937L16.1653 13H16.1653V15ZM17.6798 11.6937L16.6943 10.5512L15.1799 11.8576L16.1653 13L17.6798 11.6937ZM16.6943 10.5512C16.1804 9.95546 15.8536 9.22138 15.7548 8.44083L13.7706 8.69198C13.9188 9.86281 14.409 10.9639 15.1799 11.8576L16.6943 10.5512ZM15.7548 8.44083L15.3103 4.92887L13.3261 5.18002L13.7706 8.69198L15.7548 8.44083ZM15.3103 4.92887C14.8814 1.54045 11.9991 -1 8.58367 -1V1C10.9916 1 13.0237 2.79108 13.3261 5.18002L15.3103 4.92887Z'
            fill='#F35064'
            mask='url(#path-1-inside-1)'
        />
        <mask id='path-3-inside-2' fill='white'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.58447 13.001C4.58447 15.2096 6.3749 17 8.5835 17C10.7921 17 12.5825 15.2096 12.5825 13.001H4.58447Z'
            />
        </mask>
        <path
            d='M4.58447 13.001V12.001H3.58447V13.001H4.58447ZM12.5825 13.001H13.5825V12.001H12.5825V13.001ZM8.5835 16C6.92718 16 5.58447 14.6573 5.58447 13.001H3.58447C3.58447 15.7619 5.82261 18 8.5835 18V16ZM11.5825 13.001C11.5825 14.6573 10.2398 16 8.5835 16V18C11.3444 18 13.5825 15.7619 13.5825 13.001H11.5825ZM12.5825 12.001H4.58447V14.001H12.5825V12.001Z'
            fill='#F35064'
            mask='url(#path-3-inside-2)'
        />
    </svg>
));

export default Notification;
